import Watermark from './src/main.vue';

/* istanbul ignore next */
Watermark.install = function(Vue) {
  Vue.component(Watermark.name, Watermark);
};

export default Watermark;
